<div class="flex items-center bg-gray-1000 rounded">

  <!-- profile picture -->
  <div class="px-2 flex items-center justify-center">
    <app-profile-picture class="w-7 h-7" [fitMedProfileId]="fitMedProfileId"></app-profile-picture>
  </div>

  <div class=" flex items-center bg-gray-950 text-white text-gray-500 px-3 rounded-r py-1">
    <div class="flex flex-col">
      <!-- title -->
      <p class="text-sm font-bold text-black dark:text-white">{{ fullName }}</p>

      <!-- subtitle -->
      <div class="text-xs">
        <div #ref>
          <ng-content select="[subtitle]"></ng-content>
        </div>

        @if (!ref.childNodes.length) {
          <!-- gender && dob if no sub title -->
          @if (!fitMedProfileValue) {
            <app-gender [fitMedProfile]="fitMedProfileValue" [name]="true" [icon]="true"></app-gender>
            <span>|</span>
            <span>{{ fitMedProfileValue?.doB | localizedDate: 'mediumDate' }}</span>
          }
        }
      </div>
    </div>

    <ng-content select="[inline]"></ng-content>
  </div>
</div>